function csrfToken() {
  return document.querySelector('meta[name="csrf-token"]')?.content
}

export async function fetchLoopState() {
  const response = await fetch("/loop_state.json", {
    credentials: "same-origin",
    headers: { Accept: "application/json" }
  })

  if (!response.ok) {
    const body = await response.json().catch(() => ({}))
    throw new Error(body.error || `Loop state fetch failed (${response.status})`)
  }

  return response.json()
}

export async function patchLoopState(snapshot) {
  const response = await fetch("/loop_state.json", {
    method: "PATCH",
    credentials: "same-origin",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
      "X-CSRF-Token": csrfToken()
    },
    body: JSON.stringify({ loop_state: snapshot })
  })

  if (!response.ok) {
    const body = await response.json().catch(() => ({}))
    throw new Error(body.error || `Loop state update failed (${response.status})`)
  }

  return response.json()
}
